"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenewalMobileMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));
var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _paperRoot;
  return {
    paperRoot: (_paperRoot = {
      position: "fixed",
      width: "100%",
      bottom: 0,
      borderRadius: "4px 4px 0px 0px",
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)",
      maxHeight: "100vh"
    }, _defineProperty(_paperRoot, "maxHeight", "calc(var(--vh, 1vh) * 100)"), _defineProperty(_paperRoot, "overflowY", "auto"), _paperRoot)
  };
});
var RenewalMobileMenu = function RenewalMobileMenu(props) {
  var open = props.open,
    children = props.children,
    classes = props.classes,
    container = props.container,
    onClose = props.onClose,
    paperClasses = props.paperClasses,
    title = props.title,
    c = props.colors;
  var colors = c !== null && c !== void 0 ? c : _pittaModules.LightColors;
  var innerClasses = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openModal = _useState2[0],
    setOpenModal = _useState2[1];
  (0, _react.useEffect)(function () {
    if (open) {
      setOpenModal(true);
    } else {
      var timeout = setTimeout(function () {
        setOpenModal(false);
      }, 300);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [open]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    "aria-labelledby": "transition-modal-title",
    "aria-describedby": "transition-modal-description"
    // className={innerClasses.modal}
    ,
    container: container,
    open: openModal,
    onClose: onClose,
    closeAfterTransition: true,
    BackdropComponent: _Backdrop.default,
    BackdropProps: {
      timeout: 500,
      style: {
        opacity: 0.3
      }
    },
    style: {
      zIndex: 2147483648
    }
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Slide, {
    in: open,
    direction: "up"
  }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
    elevation: 0,
    classes: {
      root: (0, _clsx.default)(innerClasses.paperRoot, paperClasses)
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      padding: "0 16px",
      marginTop: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "BodyBold",
    htmlColor: colors.primary["1"]
  }, title)), /*#__PURE__*/_react.default.createElement(_MenuList.default, {
    autoFocusItem: open,
    id: "menu-list-grow",
    classes: classes,
    style: {
      padding: "4px 0"
    }
  }, children)))));
};
exports.RenewalMobileMenu = RenewalMobileMenu;